<template>
  <v-container>
    <v-layout>
      <v-flex style="padding-top: 5%">
        <v-card elevation="20">
          <v-card-text>
            <v-form @submit.prevent="login">
              <v-layout>
                <v-flex>
                  <v-text-field
                    name="usrn"
                    label="Nombre de usuario"
                    v-model="usrn"
                    id="usrn"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field
                    name="pwd"
                    label="Contraseña"
                    v-model="pwd"
                    id="pwd"
                    required
                    type="password"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-btn color="#015CAB" style="color: white" type="summit"
                    >Login</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-alert type="error" :value="unvalid"
            >Usuario o contraseña incorrecta</v-alert
          >
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { setCookie, userLogin, setWithExpiry } from "@/utils/apiRequest.js";
export default {
  data() {
    return {
      usrn: "",
      pwd: "",
      unvalid: false,
      reload: false,
    };
  },
  methods: {
    async login() {
      let response = await userLogin(this);
      if (response) {
        if (response.data.status == "success") {
          this.unvalid = false;
          setCookie("jwt", response.data.token, 24);
          setWithExpiry("jwt", response.data.token, 24);
          setWithExpiry("user", JSON.stringify(response.data.user), 24);
          this.$router.replace("/#logged");
        } else {
          this.unvalid = true;
        }
      } else {
        this.unvalid = true;
      }
    },
  },
};
</script>